module.exports = __webpack_public_path__ + "Lato-Regular.01f09144fb08c2185c04.woff";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Regular.woff
// module id = ../../../../../src/assets/fonts/Lato-Regular.woff
// module chunks = styles